// Mirrors mealz-api's isOpenAt(): equal open and close times mean open all day.
// Both times are HH:MM(:SS) strings, so they compare as text.
export const isOpenAllDay = (openTime: string, closeTime: string): boolean =>
  openTime !== '' && closeTime !== '' && openTime === closeTime
